// extracted by mini-css-extract-plugin
export default {"main":"Banner_main__3p4So","Abtp":"Banner_Abtp__PXlHS"};